import { env } from '../../../env.js'

const MAIN_REJESTR_LANG1 = env.MAIN_REJESTR_LANG1
const MAIN_REJESTR_API_SHORT = env.MAIN_REJESTR_API_SHORT
const MAIN_REJESTR_API_LONG = env.MAIN_REJESTR_API_LONG

export { MAIN_REJESTR_LANG1, MAIN_REJESTR_API_SHORT, MAIN_REJESTR_API_LONG }
